import React from "react";
import s from "../DisclaimerBlock.module.scss";
import type { RichTextContent } from "../../../lib/storyblok/types/fieldtypes/richText";
import BlockIntro from "../../Common/BlockIntro";

type Props = {
  disclaimerRestrictedAccessContentDescription: RichTextContent;
  disclaimerRestrictedAccessTitle: string;
};

const RestrictedAccessComponent = ({
  disclaimerRestrictedAccessContentDescription,
  disclaimerRestrictedAccessTitle,
}: Props) => {
  return (
    <div className={s.restrictedAccess}>
      <BlockIntro
        title={disclaimerRestrictedAccessTitle}
        description={disclaimerRestrictedAccessContentDescription}
        width={"full"}
        alignment={"alignLeft"}
      />
    </div>
  );
};

export default RestrictedAccessComponent;
